const columns = [
    {
        title: "User",
        dataIndex: "user",
    },
    {
        title: 'Ticket No.',
        dataIndex: 'ticketNo',
        // sorter: (a, b) => a?.ticketNo - b?.ticketNo,
    },
    {
        title: 'Query Type',
        dataIndex: 'queryName',
        // sorter: (a, b) => a?.queryName?.localeCompare(b?.queryName),
    },
    {
        title: 'Title',
        dataIndex: 'title',
        // sorter: (a, b) => a?.title?.localeCompare(b?.title),
    },
    {
        title: 'Create At',
        dataIndex: 'createdAt',
    },
    {
        title: 'Priority',
        dataIndex: 'priority',
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Details',
        dataIndex: 'details',
    },
];

export default columns;